import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import './AdminLayout.css';
import { authApi } from '../api/auth';

export const AdminLayout = () => {
  return (
    <div className="admin-layout">
      <nav className="admin-sidebar">
        <div className="sidebar-content">
          <div className="sidebar-header">
            <h3>Admin Panel</h3>
          </div>
          <ul className="sidebar-nav">
            <li>
              <NavLink to="/admin/settings">
                Settings
              </NavLink>
            </li>
            <li>
              <NavLink to="/admin/subscribers">
                Subscribers
              </NavLink>
            </li>
            <li>
              <NavLink to="/admin/charts-analytics-bi">
                Charts Analytics BI
              </NavLink>
            </li>
            <li>
              <NavLink to="/admin/track">
                Track
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="sidebar-footer">
          <button 
            onClick={() => {
              localStorage.removeItem('isAuthenticated');
              authApi.logout();
              window.location.href = '/admin/login';
            }}
            className="logout-button"
          >
            Logout
          </button>
        </div>
      </nav>
      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
}; 